import React, { ReactNode } from 'react';

const Flex = ({
  children,
  alignItems,
  justifyContent,
  className = '',
  mobileFlex = true,
  flexDirection = 'row',
}: FlexProps) => {
  const getFlexResponsive = () => (mobileFlex ? 'd-flex' : 'd-md-flex');

  return (
    <div
      className={`${getFlexResponsive()} ${className} ${
        flexDirection ? 'flex-' + flexDirection : ''
      } ${alignItems ? 'align-items-' + alignItems : ''} ${
        justifyContent ? 'justify-content-' + justifyContent : ''
      }`}
    >
      {children}
    </div>
  );
};

interface FlexProps {
  children?: ReactNode;
  className?: string;
  alignItems?: string;
  flexDirection?: string;
  justifyContent?: string;
  mobileFlex?: boolean;
}

export default Flex;
